import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Card, Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';

export class OrdersPage extends Component {
  render() {
    const createButton = (
      <Link to="/orders/create">
        <Button color="primary">Create new order</Button>
      </Link>
    );
    return (
      <Page>
        <TitleBar icon="users" title="Orders" button={createButton} />
        <Card className="content pa3">
          <h3 className="h5 h-auto">What this page will be</h3>
          <p>
            Even though we'll be able to see any orders for a given customer, we'll still want to see an overview of all
            orders. They will be found here.
          </p>
          <p>
            At a summary level we'll be able to see how many orders we have yet to fulfill, or which orders are due to
            go out for delivery, etc. From here you'll also be able to create a new order for a customer or dive into an
            individual order and see more detail that way.
          </p>
        </Card>
      </Page>
    );
  }
}

export default connect(state => state)(OrdersPage);



// WEBPACK FOOTER //
// ./src/pages/orders/orders.jsx